<template>
  <div class="containerfluid">
    <apexchart
      :key="chartdata"
      height="100%"
      width="100%"
      :options="ApexChartOptions"
      :series="ApexChartOptions.series"
    ></apexchart>
    <div class="text-center font-weight-bold mt-5">
      <p>مجموع مانده حساب ها</p>
      <p>{{ $Comma3ragham(sumMande) }} <span>ریال</span></p>
    </div>
  </div>
</template>
<script>
export default {
  name: "AccountsChart",
  data() {
    return {
      chartdata: 0,
      sumMande: 0,
      ApexChartOptions: {
        chart: {
          type: "pie",
        },
        dataLabels: {
          enabled: true,
          style: {
            fontWeight: "normal",
            colors: ["#000"],
          },
        },
        colors: [
          "#FF595E",
          "#FFCA3A",
          "#8AC926",
          "#FF924C",
          "#C77DFF",
          "#F72585",
          "#B5179E",
          "#2EC4B6",
          "#9B5DE5",
          "#F15BB5",
          "#00BBF9",
        ],
        states: {
          hover: {
            filter: {
              type: "lighten",
              value: 0.05,
            },
          },
          active: {
            filter: {
              type: "lighten",
              value: 0.03,
            },
          },
        },
        series: [],
        labels: [],
        stroke: {
          show: false,
        },
        tooltip: {
          theme: "light",
          style: {
            color: "#000",
            fontSize: "12px",
            fontFamily: "IRANSans, Tahoma, Arial",
          },
          y: {
            formatter: function (val) {
              return Number(val || 0).toLocaleString("en-US");
            },
          },
        },
      },
    };
  },
  methods: {
    GetAcconts() {
      var DataAxiosRow = {
        ArryfildValue: "",
        Method: "Post",
        Action: "ListTaahodat",
        Token: this.$session.get("TokenNetPa"),
      };
      var list = [];
      const formData = new FormData();
      formData.append(
        "wwwtblAzaId",
        this.$session.get("UserInfoNetPa").wwwtblAzaId,
      );
      formData.append("wwwtblSarfaslTypeId", 2);
      DataAxiosRow.ArryfildValue = formData;
      this.$PostFormData(DataAxiosRow).then((data) => {
        data.forEach((element) => {
          element.mande = element.mande + element.sumMabTaeedNaShode;
          this.ApexChartOptions.labels.push(element.desNoe);
          this.ApexChartOptions.series.push(element.mande);
          this.sumMande += element.mande;
        });
      });
    },
  },
  created() {
    this.GetAcconts();
  },
};
</script>
